import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import DashboardService from "services/DashboardService";

export const getDashboardSummary = createAsyncThunk(
  "dashboard/getSummary",
  async (_, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getDashboardSummary();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getDashboardActionItems = createAsyncThunk(
  "dashboard/getDashboardActionItems",
  async ({ read = false }, thunkAPI) => {
    try {
      const response = await DashboardService.getActionItems({ read });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const dismissActionItem = createAsyncThunk(
  "dashboard/dismissActionItem",
  async (id) => {
    await DashboardService.dismissActionItem(id);
    return id;
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    summary: null,
    loading: false,
    error: null,
    actionItems: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboardSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.summary = action.payload;
      })
      .addCase(getDashboardSummary.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getDashboardActionItems.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboardActionItems.fulfilled, (state, action) => {
        state.loading = false;
        state.actionItems = action.payload?.data || [];
      })
      .addCase(getDashboardActionItems.rejected, (state) => {
        state.loading = false;
      })
      .addCase(dismissActionItem.fulfilled, (state, action) => {
        state.actionItems = state.actionItems.filter(
          (item) => item._id !== action.payload
        );
      });
  },
});

export default dashboardSlice.reducer;
